import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { API_BASE_URL, ASSET_URL } from '../config';
import { RiLoader4Line } from 'react-icons/ri';

const CollaborationSection = () => {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPartners = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/partners/read.php`);
                const data = await response.json();
                if (response.ok) {
                    setPartners(data.records || []);
                }
            } catch (error) {
                console.error('Error fetching partners:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPartners();
    }, []);

    // Double the array for seamless infinite scroll
    const scrollPartners = [...partners, ...partners];

    return (
        <section className="py-24 bg-white overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="text-center mb-16">
                    <motion.span
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="text-[10px] font-black text-emerald-600 uppercase tracking-[0.4em] mb-4 block"
                    >
                        Our Global Partners
                    </motion.span>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.1 }}
                        className="text-4xl md:text-5xl font-bold text-slate-900 font-display tracking-tight leading-[1.2]"
                    >
                        Collaborating for a <span className="text-emerald-600 italic font-display">Sustainable Future.</span>
                    </motion.h2>
                </div>

                <div className="relative group">
                    {/* Gradient Fades for Scroll Edge - Polished for white theme */}
                    <div className="absolute left-0 top-0 bottom-0 w-40 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
                    <div className="absolute right-0 top-0 bottom-0 w-40 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

                    <div className="flex overflow-hidden">
                        {loading ? (
                            <div className="flex gap-20 py-10 w-full justify-center">
                                <RiLoader4Line className="animate-spin text-emerald-500 text-4xl" />
                            </div>
                        ) : (
                            <motion.div
                                className="flex gap-20 py-10"
                                animate={{
                                    x: [0, -100 * partners.length - (20 * partners.length)]
                                }}
                                transition={{
                                    duration: 30,
                                    repeat: Infinity,
                                    ease: "linear"
                                }}
                            >
                                {scrollPartners.map((partner, index) => (
                                    <div
                                        key={index}
                                        className="flex-shrink-0 flex items-center justify-center grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer"
                                        style={{ width: '160px' }}
                                    >
                                        <img
                                            src={partner.logo_url.startsWith('http') ? partner.logo_url : `${ASSET_URL}${partner.logo_url}`}
                                            alt={partner.name}
                                            className="max-h-12 w-auto object-contain"
                                        />
                                    </div>
                                ))}
                            </motion.div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CollaborationSection;
